import(/* webpackMode: "eager" */ "/home/runner/work/galapagos/galapagos/apps/web/src/app/global-error.tsx");
